import { Injectable } from '@angular/core';
import { MapMode, MapModes } from './shared';

@Injectable()
export class PanMode extends MapMode {
  type = MapModes.PAN;

  setup() {
    this.map.touchZoom.enable();
    this.map.doubleClickZoom.enable();
    this.map.scrollWheelZoom.enable();
    this.map.keyboard.enable();
    this.map.dragging.enable();
  }
}
